export var initialSteps = [
    { label: 'Bestellung', route: '/', completed: false },
    { label: 'Ansprechpartner', route: '/address', completed: false },
    { label: 'Zahlungsoptionen', route: '/payment', completed: false },
    { label: 'Datenschutz und AGB', route: '/terms', completed: false },
    { label: 'Zusammenfassung', route: '/summary', completed: false },
    { label: 'Fertig', route: '/complete', completed: false },
];
